import { apiClient } from './client';
import type { ApiResponse, TenantJob, JobStatus, JobType } from './types';

export async function listJobs(
  params: {
    status?: JobStatus;
    type?: JobType;
    tenantCode?: string;
    limit?: number;
    offset?: number;
  } = {},
) {
  const r = await apiClient.get<ApiResponse<{ items: TenantJob[] }>>('/jobs', { params });
  return r.data.data!;
}

export async function retryJob(jobId: number) {
  const r = await apiClient.post<ApiResponse<{ id: number; status: 'pending' }>>(`/jobs/${jobId}/retry`);
  return r.data.data!;
}
